import { useEffect } from 'react';
import debounce from 'lodash.debounce';

const touchCoordinates = {};

const onTouchStart = function(e) {
    const { clientX, clientY } = e.touches[0];
    Object.assign(touchCoordinates, { clientX, clientY });
};

const createOnTouchMoveHandler = (update) => (e) => {
    const changedTouches = e.changedTouches && e.changedTouches[0];
    const { clientX, clientY } = changedTouches;
    const dX = clientX - touchCoordinates.clientX;
    const dY = clientY - touchCoordinates.clientY;
    if (Math.abs(dX) > Math.abs(dY) && dX) {
        update(dX);
    }
};

const SwipeForMobile = ({ update }) => {
    const onTouchMove = debounce(createOnTouchMoveHandler(update), 600);
    useEffect(() => {
        window.addEventListener('touchstart', onTouchStart);
        window.addEventListener('touchmove', onTouchMove);
        return () => {
            window.removeEventListener('touchstart', onTouchStart);
            window.removeEventListener('touchmove', onTouchMove);
        };
    }, []);
    return null;
};

export default SwipeForMobile;
